import { render, staticRenderFns } from "./CCases.vue?vue&type=template&id=68af1d1b"
import script from "./CCases.vue?vue&type=script&lang=js"
export * from "./CCases.vue?vue&type=script&lang=js"
import style0 from "./CCases.vue?vue&type=style&index=0&id=68af1d1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports